import { useTheme } from "@emotion/react";
import camelCase from "lodash/fp/camelCase";
import upperFirst from "lodash/fp/upperFirst";
import { useCallback } from "react";

import { useDateIntervalContext, useThemeProps } from "../../wsui/base";

import * as defaultComponents from "./post-cards";

function defaultComponentMapping({ postType }) {
  let componentName = upperFirst(
    camelCase(`${postType || "fallback"}PostCard`),
  );
  // eslint-disable-next-line import/namespace
  return defaultComponents[componentName] || defaultComponents.DefaultPostCard;
}

export default function PostCardController(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "PostCardController" });
  let { post, componentMapping = {}, visibleFields, excerptLines, ...restProps } = props;

  const { getMostRelevantDate } = useDateIntervalContext();

  post = {
    ...post,
    date: post.dates ? getMostRelevantDate(post.dates) : post.date,
  };

  const isFieldVisible = useCallback(
    (field) => post[field] && (!visibleFields ? true : !!visibleFields[field]),
    [visibleFields, post],
  );

  const Component =
    (typeof componentMapping === "function"
      ? componentMapping(post, defaultComponentMapping)
      : post.postType && componentMapping[post.postType]) ||
    defaultComponentMapping(post);

  return (
    <Component
      post={post}
      visibleFields={visibleFields}
      isFieldVisible={isFieldVisible}
      excerptLines={excerptLines}
      {...restProps}
    />
  );
}
